import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { FormStateProvider } from './FormStateMachine';
import SignUp from './SignUp';
import Success from './Success';
import URLStateInitializer from './URLStateInitializer';

function App() {
  return (
    <FormStateProvider>
      <URLStateInitializer />
      <div className="App">
        <Routes>
          <Route path="/" element={<SignUp />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/payment" element={<SignUp />} />
          <Route path="/success" element={<Success />} />
          <Route 
            path="/signup/fairway" 
            element={<Navigate to="/signup?companyId=218d90e3-3f41-4000-b6ae-467edfc4e929" replace />} 
          />
          <Route 
            path="/signup/edge-home-finance" 
            element={<Navigate to="/signup?companyId=9037c833-17c2-43fe-aec3-ae4c43cecf6c" replace />} 
          />
          <Route 
            path="/signup/west-capital" 
            element={<Navigate to="/signup?companyId=65d85af7-bdce-485e-b60a-d290bf090807" replace />}
          />
          <Route
            path="/signup/union-home" 
            element={<Navigate to="/signup?companyId=32b78cdb-ad7c-4a35-b2b4-b8a41cebf41e" replace />} 
          />
        </Routes>
      </div>
    </FormStateProvider>
  );
}

export default App;
